export default "__VITE_ASSET__BYhh7HFn__"